var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCoTwitterinline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28.291,
    height: 28.29
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.523.005A14.145 14.145 0 1028.29 14.143 13.974 13.974 0 0014.523.005m6.143 10.905c0 .141.006.281.006.424a9.083 9.083 0 01-9.012 9.256 8.779 8.779 0 01-4.858-1.462 6.124 6.124 0 00.756.047 6.234 6.234 0 003.935-1.394 3.181 3.181 0 01-2.958-2.26 3.07 3.07 0 00.6.058 3.117 3.117 0 00.831-.114 3.235 3.235 0 01-2.542-3.189.113.113 0 01.005-.042 3.048 3.048 0 001.437.405 3.265 3.265 0 01-1.411-2.708 3.325 3.325 0 01.427-1.636 8.924 8.924 0 006.53 3.4 3.271 3.271 0 013.085-4 3.133 3.133 0 012.312 1.026 6.266 6.266 0 002.015-.789 3.265 3.265 0 01-1.4 1.8 6.059 6.059 0 001.82-.51 6.6 6.6 0 01-1.578 1.681",
    fill: "#26317a"
  })));
}

export default SvgCoTwitterinline;